<script setup>
import { ref, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import LogoComponent from '@webapp/components/AppComponents/LogoComponent/LogoComponent.vue'

const { t } = useI18n()
const store = useStore()
const router = useRouter()

const websiteId = computed(() => store.getters['onboarding/websiteId'])
const menuOpen = ref(false)

const toggleMenu = () => {
    menuOpen.value = !menuOpen.value
}

const closeMenu = () => {
    menuOpen.value = false
}

const navigateTo = (name, params = {}) => {
    closeMenu()
    router.push({ name, params })
}

const logout = () => {
    closeMenu()
    store.dispatch('auth/logout')
    store.dispatch('onboarding/reset')
    router.push({ name: 'login' })
}
</script>

<template>
    <div class="mp-website-header">
        <LogoComponent class="img-fluid" style="max-width:36px;" />
        <div class="mp-menu-wrapper">
            <button class="btn btn-outline-secondary btn-sm" @click="toggleMenu">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <line x1="3" y1="12" x2="21" y2="12"></line>
                    <line x1="3" y1="6" x2="21" y2="6"></line>
                    <line x1="3" y1="18" x2="21" y2="18"></line>
                </svg>
            </button>
            <div v-if="menuOpen" class="mp-menu-backdrop" @click="closeMenu"></div>
            <div v-if="menuOpen" class="mp-menu-dropdown">
                <button class="mp-menu-item" @click="navigateTo('website')">
                    {{ t('menu.website') }}
                </button>
                <button class="mp-menu-item" @click="navigateTo('website.appointment-types', { websiteId })">
                    {{ t('menu.services') }}
                </button>
                <button class="mp-menu-item" @click="navigateTo('website.schedules', { websiteId })">
                    {{ t('menu.schedule') }}
                </button>
                <button class="mp-menu-item" @click="navigateTo('website.appointments', { websiteId })">
                    {{ t('menu.appointments') }}
                </button>
                <button class="mp-menu-item" @click="navigateTo('profile')">
                    {{ t('menu.profile') }}
                </button>
                <button class="mp-menu-item" @click="navigateTo('communication')">
                    {{ t('menu.communication') }}
                </button>
                <hr class="my-1" />
                <button class="mp-menu-item mp-menu-item--danger" @click="logout">
                    {{ t('logout') }}
                </button>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.mp-website-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.75rem 1rem;
    background-color: #fff;
    border-bottom: 1px solid #e5e7eb;
    position: sticky;
    top: 0;
    z-index: 800;
}

.mp-menu-wrapper {
    position: relative;
}

.mp-menu-backdrop {
    position: fixed;
    inset: 0;
    z-index: 899;
}

.mp-menu-dropdown {
    position: absolute;
    right: 0;
    top: calc(100% + 4px);
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    min-width: 160px;
    padding: 4px 0;
    z-index: 900;
}

.mp-menu-item {
    display: block;
    width: 100%;
    padding: 8px 16px;
    border: none;
    background: none;
    text-align: left;
    font-size: 18px;
    color: #333;
    cursor: pointer;

    &:hover {
        background-color: #f3f4f6;
    }

    &--danger {
        color: #dc3545;
    }
}
</style>
